module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('vue-ueditor-wrap', {
    attrs: {
      "config": _vm.myConfig
    },
    model: {
      value: (_vm.msg),
      callback: function($$v) {
        _vm.msg = $$v
      },
      expression: "msg"
    }
  }), _vm._v(" "), _c('p', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.showOne();
      }
    }
  }, [_vm._v("获取编辑器内容")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a69f9298","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/page/useUe.vue
// module id = 3238
// module chunks = 1